export enum Color {
    Success = '--success',
    Primary = '--primary',
    Red = '--red',
    Orange = '--orange',
    Default = '--text-main',
    LightPurple = '--light-purple',
    LightRed = '--light-red',
}
